<template>

<div v-if="loading">
    <p>Carregando Produtos do Evento...</p>
</div>

<div v-else-if="event" class="group__event_page_cover">
    <div class="group__event_page_cover__content">

        <div class="cover-image" :style="{ 'background-image': 'url(' + event.cover_image + ')' }"></div>
        <div class="cover-image-blur"></div>
        <div class="event">
            <div class="information">
                <div class="title">
                    <h1>{{ event.name }}</h1>
                </div>
                <div class="date">
                    <div class="period">
                        <i class="fa-solid fa-calendar"></i>
                        <p v-if="event.date_begin">{{ event.date_begin.getDate() }} de {{ event.date_begin.toLocaleString(DEFAULT_LOCALE, { month: 'long' }).replace('.', '') }} de {{ event.date_begin.getFullYear() }}</p>
                        <p class="date_end" v-if="event.date_end"> - {{ event.date_end.getDate() }} de {{ event.date_end.toLocaleString(DEFAULT_LOCALE, { month: 'long' }).replace('.', '') }} de {{ event.date_end.getFullYear() }}</p>
                    </div>
                </div>
                <div class="location">
                    <div class="boarding-unboarding"><i class="fa-solid fa-location-dot"></i>{{ event.location }}</div>
                </div>
                <div v-if="!isEventProductsPage()" class="buy-ticket">
                    <a v-bind:href="'/event-products/'+ event.id" class="btn__buy-cart">Comprar Ingresso</a>
                </div>
            </div>

            <div class="information-image">
                <img :src="event.thumb_image" :alt="'Imagem de capa do ' + event.name">
            </div>
        </div>

    </div>
</div>
</template>


<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import EventService from '@/services/event.service.js';

const event = ref(null);
const route = useRoute();
const loading = ref(true)

async function loadEvent() {
    try {
        const resp = await EventService.getEventById(route.params.id);

        if (typeof resp.data === 'object') {
            let data = resp.data;

            if (data.date_begin) {
                data.date_begin = new Date(data.date_begin);
            }

            if (data.date_end) {
                data.date_end = new Date(data.date_end);    
            }

            event.value = data;
        }
    } catch (e) {
        console.error('Erro ao carregar', e)
    } finally {
        loading.value = false
    }
}

function isEventProductsPage() {
    return route.name === 'Produtos do Evento'; 
}

onMounted(async () => {
    loadEvent()
})
</script>
